import React, {useState} from 'react';
import {Button, Col, Row} from 'reactstrap';
import ContactInfoForm from '../ContactInfoForm';

export default function OptinCurriculum({onStepComplete = () => {}, toggleOptinModal = () => {}, ...props}) {
  const [step, setStep] = useState(0);
  return (
    <>
      {(() => {
        switch (step) {
          default:
          case 0:
            return (
              <ContactInfoForm
                id="optin-curriculum"
                apiUrl={process.env.SF_API_URL ?? ''}
                siteId={process.env.SITE_ID ?? ''}
                optinFormId={parseInt(process.env.CURRICULUM_OPTIN_FORM_ID ?? '0')}
                onComplete={() => {
                  setStep(1);
                  onStepComplete(1);
                }}
                contactInfoFormHeader={
                  <>
                    <p className="text-center mb-2">
                      <b>Where can we send you your curriculum guide?</b>
                    </p>
                    <p className="text-center mb-4">
                      Enter your first name and email. Then, keep an eye on your inbox!
                    </p>
                  </>
                }
                contactInfoFormButtonText="Get My Curriculum Guide"
              />
            );
          case 1:
            return (
              <div className="text-center pb-4">
                <p>
                  <b>
                    Thank you for entering your name and email to receive <br className="d-none d-xl-block" />
                    the Plant-Based Coaching Certificate Curriculum.
                  </b>
                </p>
                <p>Please check your email inbox for the download link.</p>
                <Row className="justify-content-center">
                  <Col lg={6}>
                    <Button color="learn-more" onClick={toggleOptinModal}>
                      Continue Reading About the Program
                    </Button>
                  </Col>
                </Row>
              </div>
            );
        }
      })()}
    </>
  );
}
